import React from 'react';
import styled from 'styled-components';

import Button from './../Button';

const { FEATURE_REPORTS_NAVBAR_UI } = process.env;

const ReportExport = styled(({ ...rest }) => <div {...rest} />)`
    font-size: 1rem;

    .button-container {
        margin-bottom: 1em;
    }

    margin: 13px 0;
    width: 100%;
    padding: 0.5em;
    color: #000;

    .doc-container {
        width: 90%;
        margin: auto;
        border: solid 5px #ccc;
        padding: 3em;

        .doc-header {
            display: flex;

            .context {
                width: 70%;

                .title {
                    font-size: 2em;
                    font-weight: 600;
                    color: #337ab7;
                    margin-bottom: 1rem;
                }

                .sub-title {
                    font-size: 1.3em;
                    font-style: italic;
                    font-weight: 400;
                }
            }

            .logo {
                width: 30%;
                text-align: right;

                img {
                    height: 60px;
                }
            }

            padding: 1em;
            border-bottom: solid 2px #000;
        }
    }

    .criteria-subsection,
    .logic-section,
    .summary-section {
        margin: 1em 0;
        padding: 0.5em;
        border: solid #eee 2px;
        //background-color: #eee;
    }

    .concepts {
        padding: 1em;

        .concept-section {
            margin-left: 2em;
            margin-bottom: 2em;
            padding: 5px;

            //border: solid blue 2px;
            .code-section {
                margin-left: 2em;
                padding: 5px;
                margin-bottom: 2em;
                //border: solid green 2px;
            }
        }
    }

    .report-section {
        margin: 1em 0.8em;

        .reference-section {
            margin-bottom: 2em;

            .horizontal-scroll-view {
                overflow-x: scroll;

                &::-webkit-scrollbar {
                    background: transparent;
                    width: 0.5em;
                    height: 0.5em;
                }

                &::-webkit-scrollbar-thumb {
                    background: #337ab7;
                    display: block;
                    border-radius: 0.25em;
                }

                .reference-table {
                    width: 100%;
                    white-space: nowrap;

                    tr {
                        td,
                        th {
                            white-space: nowrap;
                            padding: 0.5em;
                            text-align: left;
                        }
                    }
                }
            }
        }
    }

    .section-header {
        font-size: 1.5em;
        margin: 1em 0;
    }

    .subsection-header {
        font-size: 1.3em;
        margin: 0.8em 0;
    }

    .reference-section-details {
        margin: 1em 0;
        padding: 0.5em;
        border: solid #eee 2px;
    }

    .data-row,
    .data-header {
        &.grey-bg {
            background-color: #eee;
            padding: 0.2em;
        }

        margin: 0.3em;
        display: flex;

        .header {
            font-weight: 600;
        }

        .one {
            width: 100%;
        }

        .one-half {
            width: 50%;
        }

        .one-third {
            width: 33.333%;
        }

        .two-thirds {
            width: 66.666%;
        }

        .one-fourth {
            width: 25%;
        }

        .one-fifth {
            width: 20%;
        }

        .two-fifths {
            width: 40%;
        }

        .three-fifths {
            width: 60%;
        }

        .four-fifths {
            width: 80%;
        }
    }

    .data-header {
        font-weight: 600;
        padding: 0.2em;
    }

    .data-row {
        padding: 0.2em;
    }

    @media (max-width: 768px) {
        font-size: 0.8rem;
        margin: 3px;

        .doc-container {
            width: 100%;
            margin: auto;
            border: solid 3px #ccc;
            padding: 1em;

            .doc-header {
                display: flex;

                .context {
                    width: 70%;

                    .title {
                        font-size: 1em;
                        font-weight: 600;
                        color: #337ab7;
                    }

                    .sub-title {
                        font-size: 0.8em;
                        font-style: italic;
                        font-weight: 400;
                    }
                }

                .logo {
                    width: 30%;
                    text-align: right;

                    img {
                        height: 20px;
                    }
                }

                padding: 1em;
                border-bottom: solid 1px #000;
            }
        }

        .criteria-subsection,
        .logic-section,
        .summary-section {
            margin: 1em 0;
            padding: 0.5em;
            border: solid #eee 2px;
            //background-color: #eee;
        }

        .report-section {
            margin: 0.5em 0.3em;
            font-size: 1em;

            @media (max-width: 550px) {
                font-size: 0.7em;
            }

            .reference-section {
                margin-bottom: 2em;

                .horizontal-scroll-view {
                    overflow-x: scroll;

                    &::-webkit-scrollbar {
                        background: transparent;
                        width: 0.5em;
                        height: 0.5em;
                    }

                    &::-webkit-scrollbar-thumb {
                        background: #337ab7;
                        display: block;
                        border-radius: 0.25em;
                    }

                    .reference-table {
                        width: 100%;
                        white-space: nowrap;

                        tr {
                            td,
                            th {
                                white-space: nowrap;
                                padding: 0.5em;
                                text-align: left;
                            }
                        }
                    }
                }
            }
        }

        .section-header {
            font-size: 2em;
            margin: 0.7em 0;
        }

        .subsection-header {
            font-size: 1.3em;
            margin: 0.8em 0;
        }

        .reference-section-details {
            margin: 1em 0;
            padding: 0.5em;
            border: solid #eee 2px;
        }

        .data-row,
        .data-header {
            &.grey-bg {
                background-color: #eee;
                padding: 0.2em;
            }

            margin: 0.3em;
            display: flex;

            .header {
                font-weight: 600;
            }

            .one {
                width: 100%;
            }

            .one-half {
                width: 50%;
            }

            .one-third {
                width: 33.333%;
            }

            .two-thirds {
                width: 66.666%;
            }

            .one-fourth {
                width: 25%;
            }

            .one-fifth {
                width: 20%;
            }

            .two-fifths {
                width: 40%;
            }

            .three-fifths {
                width: 60%;
            }

            .four-fifths {
                width: 80%;
            }
        }

        .concepts {
            padding: 0.5em;

            .concept-section {
                margin-left: 0.5em;
                margin-bottom: 0.5em;
                padding: 5px;

                //border: solid blue 2px;
                .data-row,
                .data-header {
                    flex-wrap: wrap;

                    .one-half {
                        width: 100% !important;
                    }
                }

                .code-section {
                    margin-left: 0.5em;
                    padding: 5px;
                    margin-bottom: 0.5em;
                    //border: solid green 2px;
                }
            }
        }

        .data-header {
            font-weight: 600;
            padding: 0.2em;
        }

        .data-row {
            padding: 0.2em;
        }
    }
`;

const ExportContainer = React.forwardRef(({ sections, title, jurisdiction, condition, back }, ref) => {
    const printRef = React.useRef(null);
    const printElem = React.useCallback(() => {
        let htmlContent = printRef?.current?.innerHTML;

        if (htmlContent) {
            let mywindow = window.open('', 'new div', 'height=400,width=600');
            mywindow.document.open();
            mywindow.document.write(`<html><head><title>${title}: Jurisdiction - ${jurisdiction} ${
                condition != null ? 'Condition: ' + condition : ''
            }</title><link rel="stylesheet" href="tempExportCSS.css" type="text/css"/></head><body>
    ${htmlContent}</body></html>`);
            mywindow.document.close();
            mywindow.focus();
            setTimeout(function() {
                mywindow.print();
                mywindow.close();
            }, 1000);
        }
        /*
        window.dataLayer.push({
            event: 'reports_buildReport',
            rckmsEventCategory: `Reports`,
            rckmsEventAction: `Export ${title}`,
            rckmsEventLabel: `${
                typeof condition !== 'undefined' && condition !== null
                    ? `${condition} for `
                    : ``
            }${typeof jurisdiction !== 'undefined' ? jurisdiction : ``}`
        });
        */
        return true;
    }, [printRef]);

    React.useImperativeHandle(
        ref,
        () => ({
            print: () => {
                printElem();
            }
        }),
        [printElem]
    );

    return (
        <ReportExport className="report-export">
            {FEATURE_REPORTS_NAVBAR_UI !== 'true' && back ? (
                <div className="button-container">
                    <Button onClick={() => printElem('printElement')}>Print</Button>
                    <Button onClick={back}>Back</Button>
                </div>
            ) : null}
            <div className="doc-container" ref={printRef}>
                <div className="doc-header">
                    <div className="context">
                        <div className="title">{title}</div>
                        <div className="sub-title">Jurisdiction - {jurisdiction}</div>
                        {condition != null && <div className="sub-title">Condition - {condition}</div>}
                    </div>
                    <div className="logo">
                        <img src="logo.svg" />
                    </div>
                </div>
                <div className="doc-body">
                    {sections.map((i, index) => (
                        <div className="report-section" key={index}>
                            {i}
                        </div>
                    ))}
                </div>
            </div>
        </ReportExport>
    );
});

ExportContainer.displayName = 'ExportContainer';
export default ExportContainer;
